export const MESSAGING_PERMISSION_CODES = {
  VIEW_SECTION: 'MENSAJERIA.VER_SECCION_128',
  CREATE_MESSAGE: 'MENSAJERIA.CREAR_MENSAJE',
  VIEW_SECTION_TEMPLATES: 'MENSAJERIA.VER_SECCION_130',
  CREATE_TEMPLATE: 'MENSAJERIA.CREAR_PLANTILLA',
  PREVIEW_TEMPLATE: 'MENSAJERIA.VISTA_PREVIA',
  EDIT_TEMPLATE: 'MENSAJERIA.EDITAR_PLANTILLA',
  DELETE_TEMPLATE: 'MENSAJERIA.ELIMINAR_PLANTILLA',
  CAMPAIGNS: 'MENSAJERIA.CAMPANAS',
  VIEW_SECTION_CAMPAIGNS: 'MENSAJERIA.VER_SECCION_136',
  CREATE_CAMPAIGN: 'MENSAJERIA.CREAR_CAMPANA',
  VIEW_CAMPAIGN: 'MENSAJERIA.VER_CAMPANA',
  DELETE_CAMPAIGN: 'MENSAJERIA.ELIMINAR_CAMPANA',
  TASKS_AND_NOTIFICATIONS: 'MENSAJERIA.TAREAS_Y_NOTIFICACIONES',
  VIEW_SECTION_TASKS: 'MENSAJERIA.VER_SECCION_141',
  CREATE_TASK: 'MENSAJERIA.CREAR_TAREA',
  EDIT_TASK: 'MENSAJERIA.EDITAR_TAREA',
  DELETE_TASK: 'MENSAJERIA.BORRAR_TAREA',
};
